<template>
    <a-modal title="变更手机号"
             :width="500"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="confirmPhone"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form" class="form1">
            <a-form-item label="旧手机号">
                <span class="size3 color-black bold">{{account.phone}}</span>
            </a-form-item>
            <a-form-item label="新手机号">
                <a-input
                        v-model ="newPhone"
                        placeholder = '请输入新手机号'
                >
                </a-input>
                <a-button   @click="sendCode" >
                    {{btnMsg}}
                </a-button>
            </a-form-item>
            <a-form-item label="输入验证码">
                <a-input
                        v-model="phoneCode"
                        placeholder = '请输入验证码'
                />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                queryParam: {},
                id: this.$route.query.id,
                modalLoading: false,
                params: {},
                account: '',
                newPhone: '',
                btnMsg: '发送验证码',
                timer:'',
                phoneCode: '',
                minus: 0,
                disabled: false,
            }
        },
        methods: {
            ...mapActions(['Logout']),
            ...mapGetters(['nickname', 'avatar']),
            handleLogout() {
                const that = this
                return that.Logout({}).then(() => {
                }).catch(err => {
                    that.$message.error({
                        title: '错误',
                        description: err.message
                    })
                })
            },
            initInfo(id) {
                this.phoneCode = ''
                this.newPhone = ''
                let that = this
                this.$http.get('/api/v1/supplier/account/get_account_info.json?id='+id).then(function (res) {
                    that.account = res.result.account
                })
            },
            sendCode() {
                if (this.disabled) {
                    return
                }
                // var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
                var reg =/^[1][3-9][0-9]{9}$/
                if (!reg.test(this.newPhone)) {
                    this.$message.error("请输入正确的手机号码");
                    return
                }
                if (this.newPhone === this.account.account) {
                    this.$message.error("不允许重复旧手机号");
                    return
                }
                // 校验手机号是否被绑定
                var params2 = {}
                params2.phone = this.newPhone
                let that = this
                this.$http.post('/api/v1/supplier/account/validateAccount.json',qs.stringify(params2, {allowDots: true})).then(function (res) {
                    if (res.result === false) {
                        that.$message.error('该账号已存在');
                        return
                    }
                    that.onSend();
                });

            },
            onSend() {
                let that = this
                this.$http.get('/api/v1/supplier/account/send_code.json?phone='+this.newPhone).then(function (res) {
                    if (res.code === 200) {
                        that.disabled = true
                        that.minus = 60
                        // 发送验证码
                        that.timer = setInterval(that.countDown,1000)
                        that.$message.info(res.msg)
                    }else {
                        that.$message.error(res.msg)
                    }
                });
            },
            countDown() {
                if (this.minus <= 0) {
                    this.disabled = false
                    this.btnMsg = "发送验证码"
                    clearInterval(this.timer)
                    return
                }
                this.minus = this.minus - 1
                this.btnMsg = this.minus + "  s";
            },
            confirmPhone () {
                if (!this.newPhone) {
                    this.$message.error("请输入新手机号")
                    return
                }
                if (!this.phoneCode) {
                    this.$message.error("请输入验证码")
                    return;
                }
                let that = this
                that.$confirm({
                    title: '提示',
                    content: '更改手机号后将会退出登录，你确定要更改吗?',
                    okText: '确认',
                    okType: 'primary',
                    cancelText: '取消',
                    onOk() {
                        that.modalLoading = true
                        that.$http.get('/api/v1/supplier/account/validate_phone_code.json?phoneCode='+that.phoneCode+"&phone="+that.newPhone + "&id="+that.account.id).then(function (res) {
                            that.modalLoading = false
                            if (res.code === 200) {
                                that.disabled = false
                                that.btnMsg = "发送验证码"
                                if (that.timer) {
                                    clearInterval(that.timer)
                                }
                                that.$message.info("修改成功")
                                that.handleLogout()
                            }else if (res.code === 100) {
                                that.disabled = false
                                that.btnMsg = "发送验证码"
                                if (that.timer) {
                                    clearInterval(that.timer)
                                }
                                that.$message.error("验证码错误!")
                            }
                        })
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                })
            },
        }
    };
</script>
<style lang="less" scoped>
    /deep/ .form1 .ant-form-item{
        display: flex;
    }
    /deep/ .form1 .ant-form-item-label{
        flex-grow: 0;
        flex-shrink: 0;
        width: 100px;
    }
    /deep/ .form1 .ant-form-item-control-wrapper{
        flex: 1 1 100%;
        padding-left: 20px;
    }
</style>
